export default __webpack_public_path__ + "static/media/About_Background.b4faadc7.mp4";